export default {
  en: {
    sidebar: {
      trustCentre: 'Trust centre',
      externalMonitoring: 'External monitoring',
      overview: 'Overview',
      resources: 'Resources',
      certifications: 'Certifications',
    },
    trustCentre: {
      title: 'Trust centre',
      description:
        "This supplier's trust centre and what it publishes. Found by Risk Ledger from public sources.",
      caveat: 'Sourced by Risk Ledger, not verified. Check important details.',
      fetched: 'Fetched {date}',
      notFound: {
        title: 'No trust centre found',
        description: 'They may not have one, or it may not be publicly accessible.',
      },
      noData: {
        title: 'No trust centre data yet',
        description: 'Anything Risk Ledger finds will appear here.',
      },
      rows: {
        platform: 'Platform',
        access: 'Access',
        link: 'Link',
        summary: 'Summary',
      },
      notFoundValue: 'Not found',
      access: {
        none: 'Open',
        partial: 'Partial',
        full: 'Gated',
      },
      // Display names for the vendor slugs the pipeline records, keyed by slug.
      // The slugs are the ones rl's external_trust_centres scoring recognizes.
      platforms: {
        safebase: 'SafeBase',
        vanta: 'Vanta',
        drata: 'Drata',
        whistic: 'Whistic',
        conveyor: 'Conveyor',
        secureframe: 'Secureframe',
        trustshare: 'TrustShare',
        onetrust: 'OneTrust',
      },
      extraInfo: 'Extra info',
    },
    policies: {
      title: 'Policies',
      description:
        'Policies this supplier publishes, like privacy, security and data processing. Found by Risk Ledger from public sources.',
      caveat: 'Sourced by Risk Ledger, not verified. Check important details.',
      fetched: 'Fetched {date}',
      notFound: {
        title: 'No policies found',
        description: 'They may not publish them online or may only share them on request.',
      },
      noData: {
        title: 'No policy data yet',
        description: 'Anything Risk Ledger finds will appear here.',
      },
      // One label per key the mapping prompt's schema requires. The key is the
      // wire name; the label is the document a client expects to open.
      labels: {
        privacy: 'Privacy policy',
        cookie: 'Cookie policy',
        terms: 'Terms and conditions',
        security: 'Security policy',
        dpa: 'Data processing agreement',
        subProcessorList: 'Sub-processor list',
      },
      extraInfo: 'Extra info',
    },
    feedback: {
      positive: 'Accurate',
      negative: 'Inaccurate',
      submitted: {
        positive: 'Thanks for your feedback.',
        negative: "Thanks. We've flagged this for review.",
      },
      error: "Couldn't send your feedback. Try again.",
    },
    certificates: {
      title: 'Certifications',
      description:
        "Certifications we've found for this supplier from public registries and their trust centre.",
      flagMissing: 'Flag missing certifications',
      searchPlaceholder: 'Search certifications...',
      entity: 'Certifications',
      unknown: 'Unknown',
      columns: {
        certification: 'Certification',
        certifiedEntity: 'Certified entity',
        sources: 'Source',
        status: 'Status',
        expiry: 'Expiry',
      },
      noResults: {
        title: 'No matching certifications',
        description: 'Try a different search or remove a filter.',
      },
      drawer: {
        certifiedEntity: 'Certified entity name',
        expiring: 'Expiring',
        accreditationBody: 'Accreditation body',
        issuingBody: 'Issuing body',
        certificateNumber: 'Certificate number',
        sourceDescriptions: {
          iafCertSearch: 'Accreditation database · independently verified',
          webScraped: 'Published by the supplier · self-attested',
        },
      },
    },
  },
};
